import { Space, Row, Col } from "antd";
import React from "react";
import Box from "../../../../../components/Box/Box";
import SummaryCard from "./SummaryCard";
import { CalendarTwoTone } from '@ant-design/icons';

const Contributions = () => {
    const PayCycleData = {
        heading: {
            name: 'Contributions',
            description: '',
            icon: <CalendarTwoTone />
        },
        data: [
            {
                name: 'PF Contribution is applicable',
                value: 'Yes',
                status: true
            },
            {
                name: `Employee's PF will be the proportion of basic pay above the legally required minimum.`,
                value: 'No',
                status: false
            },
            {
                name: 'PF computation Override at the pay structure level',
                value: 'No',
                status: false
            },
            {
                name: 'The provident fund contribution made by employees is subtracted from their yearly salary.',
                value: 'Yes',
                status: true
            }, {
                name: "Additional provident fund contributions are made on top of an employee's annual wage.",
                value: 'Yes',
                status: true
            },
            {
                name: "PF contribution Override, PF opt-out, PF limit to statutory",
                value: 'Yes',
                status: true
            }, {
                name: "Employee State Insurance (ESI)",
                value: 'Enabled',
                status: true
            }, {
                name: "Labor Welfare Fund (LWF)",
                value: 'Enabled',
                status: true
            }
        ]
    }

    return <>
        <Space direction="vertical" style={{ width: '100%' }}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Box title={PayCycleData.heading.name}>
                        <SummaryCard data={PayCycleData} span={24} />
                    </Box>
                </Col>
            </Row>
        </Space >
    </>
}

export default Contributions;